// extracted by mini-css-extract-plugin
export default {"price":"h7-z","onSale":"i7-z","msrpLabelPrice":"j7-z","msrpLabel":"k7-z","originalPrice":"l7-z","percentOff":"m7-z"};